// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2mBvH","options":"AnswerScale_options__2EAeH","selected":"AnswerScale_selected__1nSRz"};